module.exports = __webpack_public_path__ + "img/flex-o.b2293e2a.svg";